import { Button, Typography, Stack } from '@mui/material';
import { Link, Redirect } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { LogoWithTagline } from 'components/LogoWithTagline';
import { useQueryParams } from 'hooks/useQueryParams';

export const ResetPasswordConfirmationContent = (): JSX.Element => {
  const { t } = useTranslation();
  const [{ email }] = useQueryParams<{ email?: string }>();

  // Defensive guard: this page is normally reached from `ResetPasswordForm`
  // which always appends `?email=...`. Handles the edge case of a deep link
  // (bookmarked / shared / hand-edited URL) without the email param.
  if (!email) {
    return <Redirect to="/reset_password" />;
  }

  return (
    <Stack spacing={6}>
      <LogoWithTagline />

      <Stack spacing={4}>
        <Stack spacing={1}>
          <Typography component="h2" variant="h3">
            {t('resetPasswordConfirmation.subtitle')}
          </Typography>

          <Typography sx={{ lineHeight: '22px' }}>
            <Trans
              i18nKey="resetPasswordConfirmation.description"
              values={{ email: decodeURIComponent(email) }}
            >
              We sent a link to reset your password to
              <b>rafa.alvarez@gmail.com</b>. If you can&apos;t find the email,
              check your spam folder.
            </Trans>
          </Typography>
        </Stack>

        <Button
          fullWidth
          size="large"
          to={`/reset_password?email=${encodeURIComponent(email)}`}
          component={Link}
          color="neutral"
        >
          {t('resetPasswordConfirmation.button')}
        </Button>
      </Stack>
    </Stack>
  );
};
